import { AxiosResponse } from 'axios'
import axiosApi from 'modules/api'
import { CreateOrderPayload, CreateOrderResponse } from 'pages/api/orders'

const createOrder = async ({
  chainId,
  sellToken,
  sellTokenName,
  sellTokenSymbol,
  sellTokenDecimals,
  sellTokenParent,
  sellAmount,
  buyToken,
  buyTokenName,
  buyTokenSymbol,
  buyTokenDecimals,
  buyTokenParent,
  buyAmount,
  signature,
  maker,
  taker,
  staticSelector,
  staticExtradata,
  maximumFill,
  listingTime,
  expirationTime,
  salt,
}: CreateOrderPayload): Promise<string> => {
  const { data } = await axiosApi.post<
    CreateOrderResponse,
    AxiosResponse<CreateOrderResponse, CreateOrderPayload>,
    CreateOrderPayload
  >('/orders', {
    chainId,
    sellToken,
    sellTokenName,
    sellTokenSymbol,
    sellTokenDecimals,
    sellTokenParent,
    sellAmount,
    buyToken,
    buyTokenName,
    buyTokenSymbol,
    buyTokenDecimals,
    buyTokenParent,
    buyAmount,
    signature,
    maker,
    taker,
    staticSelector,
    staticExtradata,
    maximumFill,
    listingTime,
    expirationTime,
    salt,
  })
  return data.orderId
}

export default createOrder
